module.exports = __webpack_public_path__ + "img/teodora.41ec28de.png";